import { produce } from "../../../../immer/index.js";
function createCommonApi(store, getLogger, getSubscribersApi) {
  const { notifyFieldSubscribers, notifyFormSubscribers, notifyMetaSubscribers } = getSubscribersApi();
  const commonApi = {
    getValues: () => {
      return store.values;
    },
    getInitialValues: () => {
      return store.initialValues;
    },
    getMeta: () => {
      return store.meta;
    },
    getFieldValues: () => {
      const values = {};
      for (const [key, val] of Object.entries(store.fields)) {
        const fieldName = key;
        const field = val;
        values[fieldName] = field.value;
      }
      return Object.freeze(values);
    },
    setDisabled: (value) => {
      const log = getLogger();
      log("setDisabled", value);
      store.meta = produce(store.meta, (draft) => {
        draft.disabled = value;
      });
      notifyFieldSubscribers(Object.keys(store.fields));
      notifyMetaSubscribers();
      notifyFormSubscribers();
    },
    setSubmitting: (value) => {
      const log = getLogger();
      log("setSubmitting", value);
      store.meta = produce(store.meta, (draft) => {
        draft.submitting = value;
      });
      notifyFieldSubscribers(Object.keys(store.fields));
      notifyMetaSubscribers();
      notifyFormSubscribers();
    }
  };
  return commonApi;
}
export {
  createCommonApi
};
//# sourceMappingURL=createCommonApi.js.map
